import { useState } from "react";

import {
  FilesUploadDropzone as FilesUploadDropzoneBase,
  type FilesUploadDropzoneProps,
  FilesUploader,
  type Options,
  // eslint-disable-next-line boundaries/element-types, import/no-internal-modules
} from "packages/files_uploader";

import {
  getDataFromForm,
  onBeforeAddFiles,
  onRestrictionsFailed,
  onUploadFailed,
  onUploadProgress,
  onUploadStart,
  onUploadSuccess,
} from "./files-uploader-jquery";

export const FilesUploadDropzone = ({
  formId,
  dropzoneProps,
  inputProps,
  options,
  limit,
}: FilesUploadDropzoneProps & {
  formId: string;
  options?: Options;
  limit?: number;
}) => {
  const [uploader] = useState(() => {
    const { maxFileSize, maxNumberOfFiles, formUrl, $form } =
      getDataFromForm(formId);

    // Per-plan form data-limit wins; fall back to the view's limit prop
    // (UPLOADED_IMAGE_MAX_SIZE) when data-limit is blank.
    const effectiveMaxFileSize = maxFileSize ?? limit;

    // maxFileSize/maxNumberOfFiles MUST be nested under `restrictions`:
    // FilesUploader reads them from `options.restrictions`, so passing them at
    // the top level was silently ignored and Uppy fell back to its 50MB default
    // — rejecting >50MB visitor uploads despite the 100MB plan limit (ART-8474).
    const imageUploader = new FilesUploader({
      restrictions: {
        ...(effectiveMaxFileSize && { maxFileSize: effectiveMaxFileSize }),
        ...(maxNumberOfFiles && { maxNumberOfFiles }),
      },
      onBeforeAddFiles,
      onRestrictionsFailed,

      onUploadProgress,
      onUploadFailed,
      onUploadStart,
      onUploadSuccess: ({
        fileName,
        uploadUrl,
        folderName,
        fileExtension,
        publicId,
        file,
      }) => {
        onUploadSuccess({
          fileName,
          uploadUrl,
          formUrl,
          $form,
          uploadParamName: inputProps.name,
          useFilename: !!options?.useFilename,
          folderName,
          fileExtension,
          publicId,
          file,
        });
      },
    });

    return imageUploader;
  });

  return (
    <FilesUploadDropzoneBase
      uploader={uploader}
      dropzoneProps={dropzoneProps}
      inputProps={inputProps}
    />
  );
};
